export interface AuditLogChangeItem {
  id: number;
  verbose: string;
}

export interface AuditLogChangeDetail {
  value: string;
  verbose: string;
}

export interface AuditLogChange {
  class: string;
  verbose_name: string;
  to_many: boolean;
  added: AuditLogChangeItem[];
  removed: AuditLogChangeItem[];
  new: AuditLogChangeDetail;
  old: AuditLogChangeDetail;
}

export interface AuditLog {
  id: number;
  created_at: string;
  user_display: string;
  model_display: string;
  object_str: string;
  object_id: number;
  comment: string;
  changes_list: AuditLogChange[];
}

interface AuditLogItems {
  total: number;
  items: AuditLog[];
}

export enum AuditLogObjectType {
  ACCOUNT = "ACCOUNT",
  ALERT = "ALERT",
  CHECK = "CHECK",
  CHECK_TAG = "CHECK_TAG",
  CONTACT = "CONTACT",
  CREDENTIAL = "CREDENTIAL",
  DASHBOARD = "DASHBOARD",
  INTEGRATION = "INTEGRATION",
  SLA_REPORT = "SLA_REPORT",
  SCHEDULED_REPORT = "SCHEDULED_REPORT",
  STATUS_PAGE = "STATUS_PAGE",
  USER = "USER",
  AUTH = "AUTH",
  SLA_REPORT_LOGO = "SLA_REPORT_LOGO",
  MAINTENANCE_SCHEDULE = "MAINTENANCE_SCHEDULE",
}

export const AuditLogObjectTypeDisplay: Record<AuditLogObjectType, string> = {
  [AuditLogObjectType.ACCOUNT]: "Account",
  [AuditLogObjectType.ALERT]: "Alert",
  [AuditLogObjectType.CHECK]: "Check",
  [AuditLogObjectType.CHECK_TAG]: "Check Tag",
  [AuditLogObjectType.CONTACT]: "Contact",
  [AuditLogObjectType.CREDENTIAL]: "Credential",
  [AuditLogObjectType.DASHBOARD]: "Dashboard",
  [AuditLogObjectType.INTEGRATION]: "Integration",
  [AuditLogObjectType.SLA_REPORT]: "SLA Report",
  [AuditLogObjectType.SCHEDULED_REPORT]: "Scheduled Report",
  [AuditLogObjectType.STATUS_PAGE]: "Status Page",
  [AuditLogObjectType.USER]: "User",
  [AuditLogObjectType.AUTH]: "Auth",
  [AuditLogObjectType.SLA_REPORT_LOGO]: "SLA Report Logo",
  [AuditLogObjectType.MAINTENANCE_SCHEDULE]: "Maintenance Schedule",
};

export interface AuditLogListResult {
  auditLogs: AuditLogItems;
  auditLogObjectTypes: AuditLogObjectType[];
}
